import { pass, } from '../api';
import oneLni from '../instance';
import {
    MutationTypes,
    ManifestServiceStatus,
    RouteState,
} from './store.constants';

export const actions = {
    // eslint-disable-next-line arrow-body-style
    NAVIGATE_WITH_VALIDATION: (context, payload) => {
        return new Promise((resolve) => {
            // this kicks off validation on this route
            context.commit(MutationTypes.AuthorizeNavigateFromRoute, {
                route: payload.fromRoute,
                id: oneLni.manifest.getRandomizedIdString(),
            });

            // this waits for the next event cycle so that
            // each component can register its error if it is not valid.
            setTimeout(() => {
                oneLni.manifest.populateRouteErrorList(context.state.form, payload.fromRoute);

                let authorization = {
                    authorized: false,
                };

                if (oneLni.manifest.routeHasErrors(context.state.form, payload.fromRoute)) {
                    context.commit(
                        MutationTypes.SetRouteValidationState,
                        {
                            route: payload.fromRoute,
                            validationState: RouteState.Invalid,
                        },
                    );
                } else {
                    context.commit(
                        MutationTypes.SetRouteValidationState,
                        {
                            route: payload.fromRoute,
                            validationState: RouteState.Valid,
                        },
                    );
                    let authorized = true;

                    // TODO: Specific to WageComplaint
                    // check to see if they are trying to bypass a route that still has errors
                    // or that hasn't been entered yet.
                    // NOTE: just doing this for the main form currently
                    if ((payload.fromRoute === '/complaint-info'
                        || payload.fromRoute === '/supporting')
                        && payload.toRoute === '/confirm-submit') {
                        // check the route state of the /contact-into route
                        // user is trying to jump over it to submit
                        let routeState = context.state.routeStateDictionary
                            .find((r) => r.route === '/contact-info');
                        if (!routeState || routeState.validationState !== RouteState.Valid) {
                            authorized = false;
                        }
                    }

                    authorization.authorized = authorized;
                }

                resolve(authorization);
            }, 0);
        });
    },
    SET_FORM_FROM_MANIFEST: (context, payload) => {
        context.commit(MutationTypes.SetManifestServiceStatus, {
            manifestServiceStatus: '',
        });
        oneLni.manifest.standardize(payload.form);
        let formGuid = oneLni.manifest.getFormGuid(payload.form);
        context.commit(MutationTypes.SetForm, {
            form: payload.form,
            formName: '',
            formUrl: '',
            formGuid,
        });
    },
    SET_FORM_FROM_URL: (context, payload) => {
        context.commit(MutationTypes.SetManifestServiceStatus, {
            manifestServiceStatus: ManifestServiceStatus.Loading,
        });

        pass(payload.formName, payload.formUrl, null, payload.parameters)
            .then((form) => {
                context.commit(MutationTypes.SetManifestServiceStatus, {
                    manifestServiceStatus: '',
                });
                oneLni.manifest.standardize(form.element);
                let formGuid = oneLni.manifest.getFormGuid(form.element);
                context.commit(MutationTypes.SetForm, {
                    formName: payload.formName,
                    formUrl: payload.formUrl,
                    form: form.element,
                    formGuid,
                });
            })
            .catch((error) => {
                context.commit(MutationTypes.SetManifestServiceStatus, {
                    manifestServiceStatus: ManifestServiceStatus.Error,
                    errorMessage: error.message,
                });
            });
    },

    // eslint-disable-next-line arrow-body-style
    SUBMIT_FORM: (context) => {
        return new Promise((resolve) => {
            oneLni.manifest.standardizeForSubmit(context.state.form);
            pass(
                context.state.formName,
                context.state.formUrl,
                context.state.form,
            ).then((response) => {
                if (response.ReturnValue) {
                    context.commit(MutationTypes.SetConfirmationId, {
                        confirmationId: response.ReturnValue,
                        confirmationGuid: context.state.formGuid,
                    });
                    resolve({
                        submitted: true,
                    });
                } else {
                    oneLni.manifest.standardize(response.element);
                    context.commit(MutationTypes.SetSubmitFormHasBeenAttempted, {
                        submitFormHasBeenAttempted: true,
                    });
                    context.commit(MutationTypes.SetForm, {
                        form: response.element,
                    });
                    oneLni.manifest.populateAllRouteErrorLists(context.state.form);
                    oneLni.manifest.updateGlobalError(context.state.form);
                    let editRoute = oneLni.manifest.getRouteForFirstError(context.state.form);
                    resolve({
                        submitted: false,
                        route: editRoute,
                    });
                }
            });
        });
    },
    TOGGLE_MODAL: (context, payload) => {
        let collapseNode = oneLni.manifest
            .getNearestAncestorByTagName(context.state.form, payload.id, 'x-collapse');
        if (collapseNode) {
            collapseNode.attributes.visible = payload.visible;
        }
    },
};



// WEBPACK FOOTER //
// ./source/framework/instance/store.actions.js